export default __webpack_public_path__ + "cf4e70265aa7caf58380302b97875b56.gif";